var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show && _vm.showText
    ? _c(
        "Button",
        {
          staticClass: "d-flex align-items-center",
          nativeOn: {
            click: function ($event) {
              return _vm.deleteSelectItems.apply(null, arguments)
            },
          },
        },
        [
          _c("i", { staticClass: "bi-trash3 me-2" }),
          _vm._v("\n    " + _vm._s(_vm.text) + "\n"),
        ]
      )
    : _vm.show
    ? _c(
        "Button",
        {
          nativeOn: {
            click: function ($event) {
              return _vm.deleteSelectItems.apply(null, arguments)
            },
          },
        },
        [
          _c("i", { staticClass: "bi-trash3" }),
          _vm._v("\n    " + _vm._s(_vm.text) + "\n"),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }